import { normalizeLocale } from './locale';

type LocalizedEdge = { node?: { preferred_language?: string } };

/**
 * Static queries return every sourced language variant of an item. Keep the
 * variants for the page language, falling back to the default language.
 */
export function pickLocalizedEdges<T extends LocalizedEdge>(
    edges: T[] | undefined,
    language: string | undefined
): T[] {
    const inLanguage = (locale: string) =>
        (edges || []).filter(
            (edge) =>
                normalizeLocale(edge?.node?.preferred_language || 'default') ===
                locale
        );
    const pageLanguage = inLanguage(normalizeLocale(language || 'default'));
    if (pageLanguage.length) return pageLanguage;
    const defaults = inLanguage('default');
    return defaults.length ? defaults : edges || [];
}
